import { Box } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useEffect, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';
import ViewHomeInsuranceDialog from '../components/dialog/ViewHomeInsuranceDialog';

import { Rebrandings } from '../utils';

const rebrandingKey =
  process.env.REACT_APP_CLIENT && process.env.REACT_APP_CLIENT in Rebrandings
    ? (process.env.REACT_APP_CLIENT as keyof typeof Rebrandings)
    : 'wbg';

const MainLayout = observer(() => {
  const [showDialog, setShowDialog] = useState(false);

  const hasCheckedInsurance = useRef(false);

  const getInsuranceDialogShown = (): number => {
    const saved = localStorage.getItem('insuranceDialogShown');
    if (!saved) return 0;
    return parseInt(saved, 10);
  };

  const storeInsuranceDialogShown = (prev: number): number => {
    const newShown = prev + 1;

    localStorage.setItem('insuranceDialogShown', JSON.stringify(newShown));
    return newShown;
  };

  useEffect(() => {
    if (hasCheckedInsurance.current) return;
    hasCheckedInsurance.current = true;
    const shownCount = getInsuranceDialogShown();

    if (shownCount < 3) {
      setShowDialog(true);
      storeInsuranceDialogShown(shownCount);
    } else {
      setShowDialog(false);
    }
  }, []);

  return (
    <Box>
      <Outlet />
      {rebrandingKey.includes('wbg') && (
        <ViewHomeInsuranceDialog
          open={showDialog}
          onClose={() => setShowDialog(false)}
        />
      )}
    </Box>
  );
});

export default MainLayout;
